<template>
  <form @submit.prevent="updatePromoBanner()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit Promo Banner</h5>
        <button
          ref="modalCloseBtn"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <label for="">Serial</label>
            <input
              type="number"
              min="0"
              v-model="formValue.serial"
              class="form-control"
              required
            />
          </div>
          <div class="col-sm-6">
            <label for=""
              >Banner Image <span class="text-warning">(Max 2 MB)</span></label
            >
            <br v-if="photoPreview || promoBanner.image" />
            <img
              class="border border-secondary rounded mb-1"
              v-show="promoBanner.image && !photoPreview"
              :src="promoBanner.image"
              alt=""
              width="300"
            />
            <img
              class="border border-secondary rounded mb-1"
              v-show="photoPreview"
              :src="photoPreview"
              alt=""
              width="300"
            />
            <input
              type="file"
              accept="image/png, image/gif, image/jpeg"
              class="form-control"
              style="display: none"
              ref="promo_photo"
              @change="changePhoto"
            />
            <br />
            <button class="btn btn-secondary" @click.prevent="selectPhoto">
              <i class="bi bi-camera-fill"></i> Choose
            </button>
            <button
              v-if="photoPreview"
              class="btn btn-danger"
              style="margin-left: 5px"
              @click.prevent="removePhoto"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-6">
            <label for="">Redirect Type</label>
            <select
              class="form-control"
              v-model="formValue.redirect_type"
              required
            >
              <option value="">--Select--</option>
              <option value="External">External</option>
              <option value="Web View">Web View</option>
              <option value="App Section">App Section</option>
              <option value="No Redirect">No Redirect</option>
            </select>
          </div>
          <div class="col-sm-6">
            <label for="">Redirect Link</label>
            <input
              type="text"
              v-model="formValue.redirect_to"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">Update</button>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/config/axios';

export default {
  props: ['promoBanner'],
  data() {
    return {
      formValue: {
        serial: null,
        redirect_type: null,
        redirect_to: null
      },
      isLoading: false,
      photoPreview: null
    };
  },
  watch: {
    promoBanner: function () {
      this.formValue.serial = this.promoBanner.serial;
      this.formValue.redirect_type = this.promoBanner.redirect_type;
      this.formValue.redirect_to = this.promoBanner.redirect_to;
      this.removePhoto();
    }
  },
  methods: {
    emptyFormValues() {
      for (const key in this.formValue) {
        this.formValue[key] = null;
      }
      this.removePhoto();
    },
    selectPhoto() {
      this.$refs.promo_photo.click();
    },
    removePhoto() {
      this.photoPreview = null;
      this.$refs.promo_photo.value = this.$refs.promo_photo.defaultValue;
    },
    changePhoto() {
      let reader = new FileReader();
      reader.onload = (e) => (this.photoPreview = e.target.result);
      reader.readAsDataURL(this.$refs.promo_photo.files[0]);
    },
    updatePromoBanner() {
      this.isLoading = true;
      // Making of the form
      let formData = new FormData();
      Object.keys(this.formValue).map((e) => {
        if (this.formValue[e]) {
          formData.append(e, this.formValue[e]);
        }
      });
      if (this.photoPreview) {
        formData.append('image', this.$refs.promo_photo.files[0]);
        let fileSize = this.$refs.promo_photo.files[0].size / 1024 / 1024;
        if (fileSize > 2) {
          this.isLoading = false;
          this.$swal(
            'Warning',
            'Image size should not be greater than 2 MB!',
            'error'
          );
          throw 'Image size should not be greater than 2 MB!';
        }
      }

      http
        .post(`v1/promo/up/${this.promoBanner.id}`, formData)
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.$swal('Success', response.data.message, 'success');
            this.$refs.modalCloseBtn.click();
            this.emptyFormValues();
            this.$emit('refreshPromoBannerList');
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', 'Something went wrong!', 'error');
        });
    }
  }
};
</script>

<style scoped></style>
